/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ILiquidContainer containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum layout {
    stacked = 'stacked',
    flow = 'flow'
}

export const enum containerType {
    fluid = 'fluid',
    container = 'container'
}

export const enum childrenWidth {
    auto = 'auto',
    one = 'one',
    two = 'two',
    three = 'three',
    four = 'four',
    six = 'six',
    twelve = 'twelve'
}

export const enum backgroundImageSize {
    cover = 'cover',
    contain = 'contain',
    default = 'default'
}

export const enum backgroundImageRepeat {
    repeat = 'repeat',
    noRepeat = 'noRepeat'
}

export interface ILiquidContainerConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    layout?: layout;
    containerType?: containerType;
    clientRender?: boolean;
    childrenWidth?: childrenWidth;
    backgroundImage?: Msdyn365.IImageData;
    backgroundImageSize?: backgroundImageSize;
    className?: string;
    ariaLabel?: string;
    backgroundImageRepeat?: backgroundImageRepeat;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface ILiquidContainerProps<T> extends Msdyn365.IModule<T> {
    config: ILiquidContainerConfig;
    slots: {
        content: React.ReactNode[];
    };
}
